const PATH = 'fe.components.login_manager';

const messages = {
  incorrectEmailOrPassword: {
    key: `${PATH}.incorrect_email_or_password`,
    defaultValue:
      'Incorrect email or password: Please check both, or select Forgot Password.'
  },
  incorrectPhoneOrPassword: {
    key: `${PATH}.incorrect_phone_or_password`,
    defaultValue:
      'Incorrect phone number or password: Please check both, or select Forgot Password.'
  },
  incorrectCode: {
    key: `${PATH}.incorrect_code`,
    defaultValue:
      'Incorrect code: Please check your phone number and code, or select Resend Code.'
  },
  genericError: {
    key: `${PATH}.generic_error`,
    defaultValue: 'Something went wrong. Please try again.'
  },
  useDifferentLogin: {
    key: `${PATH}.use_different_login`,
    defaultValue: 'Use a different email or phone'
  },
  tryAgainIn: {
    key: `${PATH}.try_again_in`,
    defaultValue: 'Too many attempts. Please wait {{time}} to try again.'
  }
};

export default messages;
